import { createReducer, on } from '@ngrx/store';
import { UiActions, RecentlyViewedItem } from './ui.actions';

export interface UiState {
  theme: 'light' | 'dark' | 'slb';
  telaVisibility: 'none' | 'catalog' | 'all';
  domainPanel: 'Subsurface' | 'WellConstruction' | 'Production' | 'Sustainability' | 'DataManagement' | 'AI';
  darkVariant: '1' | '2';
  pricingEnableWorkflow: boolean;
  searchEnabled: boolean;
  heroVariant: 'seismic' | 'network' | 'tela' | 'cube';
  showEaProducts: boolean;
  showUnavailableButton: boolean;
  // Session-only (not persisted to localStorage). Backend team: replace with
  // an effect that calls GET /users/search-history on auth + POST on addRecentSearch.
  // recentlyViewed is also session-only — consistent with recentSearches.
  recentSearches: string[];
  recentlyViewed: RecentlyViewedItem[];
}

const initialState: UiState = {
  theme: 'light',
  telaVisibility: 'none',
  domainPanel: 'Subsurface',
  darkVariant: '1',
  pricingEnableWorkflow: false,
  searchEnabled: false,
  heroVariant: 'cube',
  showEaProducts: false,
  showUnavailableButton: false,
  recentSearches: [],
  recentlyViewed: [],
};

const MAX_RECENT = 5;

export const uiReducer = createReducer(
  initialState,
  on(UiActions.setTheme, (state, { theme }) => ({ ...state, theme })),
  on(UiActions.setTelaVisibility, (state, { telaVisibility }) => ({ ...state, telaVisibility })),
  on(UiActions.setDomainPanel, (state, { domainPanel }) => ({ ...state, domainPanel })),
  on(UiActions.setDarkVariant, (state, { variant }) => ({ ...state, darkVariant: variant })),
  on(UiActions.setSearchEnabled, (state, { enabled }) => ({ ...state, searchEnabled: enabled })),
  on(UiActions.setHeroVariant, (state, { variant }) => ({ ...state, heroVariant: variant })),
  on(UiActions.setPricingEnableWorkflow, (state, { enabled }) => ({ ...state, pricingEnableWorkflow: enabled })),
  on(UiActions.setShowEaProducts, (state, { enabled }) => ({ ...state, showEaProducts: enabled })),
  on(UiActions.setShowUnavailableButton, (state, { enabled }) => ({ ...state, showUnavailableButton: enabled })),
  on(UiActions.addRecentSearch, (state, { query }) => {
    const deduped = [query, ...state.recentSearches.filter(q => q !== query)];
    return { ...state, recentSearches: deduped.slice(0, MAX_RECENT) };
  }),
  on(UiActions.removeRecentSearch, (state, { query }) => ({
    ...state, recentSearches: state.recentSearches.filter(q => q !== query),
  })),
  on(UiActions.clearRecentSearches, (state) => ({ ...state, recentSearches: [] })),
  on(UiActions.addRecentlyViewed, (state, { product }) => {
    const deduped = [product, ...state.recentlyViewed.filter(p => p.id !== product.id)];
    return { ...state, recentlyViewed: deduped.slice(0, MAX_RECENT) };
  }),
  on(UiActions.clearRecentlyViewed, (state) => ({ ...state, recentlyViewed: [] })),
);
